import React from "react";
import { Container } from "react-bootstrap";
import "./CategoryContainer.css";
const CategoryContainer = () => {
  return (
    <div className="pb-5">
      <Container>
        <div className="section-heading text-center">
          <span>All Categories</span>
          <h2>Product Category</h2>
          <p>
            Lorem, ipsum dolor sit amet consectetur ad
          </p>
        </div>
        <div className="row">
          <div className="col-6 col-md-4 col-lg-3 py-2">
            <div className="category-item cat-bg1">
              <h4 className="m-0">All Item</h4>
              <span>58 items</span>
            </div>
          </div>
          <div className="col-6 col-md-4 col-lg-3 py-2">
            <div className="category-item cat-bg2">
              <h4 className="m-0">Women</h4>
              <span>25 items</span>
            </div>
          </div>
          <div className="col-6 col-md-4 col-lg-3 py-2">
            <div className="category-item cat-bg2">
              <h4 className="m-0">Men</h4>
              <span>84 items</span>
            </div>
          </div>
          <div className="col-6 col-md-4 col-lg-3 py-2">
            <div className="category-item  cat-bg1">
              <h4 className="m-0">Best Sale</h4>
              <span>18 items</span>
            </div>
          </div>
          <div className="col-6 col-md-4 col-lg-3 py-2">
            <div className="category-item cat-bg1">
              <h4 className="m-0">Most View</h4>
              <span>84 items</span>
            </div>
          </div>
          <div className="col-6 col-md-4 col-lg-3 py-2">
            <div className="category-item  cat-bg2">
              <h4 className="m-0">Specials</h4>
              <span>18 items</span>
            </div>
          </div>
          <div className="col-6 col-md-4 col-lg-3 py-2">
            <div className="category-item cat-bg2">
              <h4 className="m-0">Most View</h4>
              <span>84 items</span>
            </div>
          </div>
          <div className="col-6 col-md-4 col-lg-3 py-2">
            <div className="category-item  cat-bg1">
              <h4 className="m-0">Specials</h4>
              <span>18 items</span>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default CategoryContainer;
